import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { neighbours } from '../../data/artifactRealms';

const Arrow = ({ piece, dir }) => (
  <Link
    to={`/product/${piece.slug}`}
    state={{ dir }}
    className={`aarrow aarrow--${dir < 0 ? 'prev' : 'next'}`}
    aria-label={`${dir < 0 ? 'Previous' : 'Next'} artifact: ${piece.name}`}
    data-testid={dir < 0 ? 'artifact-prev-arrow' : 'artifact-next-arrow'}
  >
    <span className="aarrow-disc">
      {dir < 0 ? <ChevronLeft className="w-4 h-4" strokeWidth={1.25} /> : <ChevronRight className="w-4 h-4" strokeWidth={1.25} />}
    </span>
    <span className="aarrow-label">{piece.number} · {piece.name}</span>
  </Link>
);

export const ArtifactArrows = ({ realm, slug }) => {
  const { prev, next } = neighbours(realm, slug);
  return (
    <>
      <Arrow piece={prev} dir={-1} />
      <Arrow piece={next} dir={1} />
    </>
  );
};
